import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  selector: 'sbnb-chekin',
  template: `
    <sbnb-apps-detail-page
      vendorCode="chekin"
      name="Chekin"
      logoTile="/assets/images/apps/chekin.png"
      builtBy="Chekin"
      builtByLink="https://www.chekin.com/"
      [categories]="['Guest verification', 'Guidebook']"
      [permissions]="[
        AppPermission.propertyListingRead,
        AppPermission.enrichmentRead,
        AppPermission.financialsRead,
        AppPermission.calendarRead,
        AppPermission.calendarPartialWrite,
      ]"
      email="support@chekin.com">
      <ng-container description>
        <div class="space-y-4">
          <p>
            Chekin helps hotels and vacation rental managers automate the entire check-in process, from booking
            confirmation to check-out. With over 80,000 client properties worldwide, Chekin helps streamline operations,
            save time, enhance guest satisfaction, and generate additional revenue. Trusted by big players such as
            Interhome, Greystar, Sonder and Holidu.
          </p>

          <p>
            Chekin is designed to enhance and simplify the check-in experience, Chekin offers features such as guest
            registration and identification, remote access, sending guest information to the police, online deposits,
            upselling, and much more.
          </p>

          <p><strong>Features</strong></p>

          <ul class="space-y-3 list-disc pl-5 leading-normal">
            <li>A white-label, no-download guest app</li>
            <li>Offer an online check-in and on-brand experience from the comfort of their own devices</li>
            <li>Automatically send guest registration slips and statistical reports to the local authorities</li>
            <li>Verify the guest identity through biometric match technology</li>
            <li>Automatically calculate the tourist rates any of your properties worldwide</li>
            <li>Send automated emails at key points of the guest journey</li>
            <li>Include online deposits or damage protection in online check-in to safeguard your properties</li>
            <li>Boost your revenue by offering guests personalized upsells and experiences</li>
            <li>
              Effortlessly share important property information and personalized recommendations through digital
              guidebooks
            </li>
            <li>Connect with top smart lock systems to enable guests to effortlessly self-check-in at your property</li>
          </ul>
        </div>
      </ng-container>
      <sbnb-image-carousel
        [images]="[
          '/assets/images/apps/chekin/1.png',
          '/assets/images/apps/chekin/2.png',
          '/assets/images/apps/chekin/3.png',
          '/assets/images/apps/chekin/4.png',
          '/assets/images/apps/chekin/5.png',
          '/assets/images/apps/chekin/6.png',
          '/assets/images/apps/chekin/7.png',
          '/assets/images/apps/chekin/8.png',
          '/assets/images/apps/chekin/9.png',
          '/assets/images/apps/chekin/10.png',
        ]"
        [autoCycle]="false"></sbnb-image-carousel>
    </sbnb-apps-detail-page>
  `,
})
export class ChekinComponent {
  public AppPermission = AppPermission;
}
